import { useTheme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Label,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import CustomTooltip from "./CustomTooltip";
import Title from "./Title";
import { toast } from "react-toastify";
import api from "../../services/api";

const ChartPorDiaPeriodo = () => {
  const theme = useTheme();

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getYesterdayDate = () => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [initialSelectedDate, setInitialSelectedDate] =
    useState(getYesterdayDate);
  const [finalSelectedDate, setFinalSelectedDate] = useState(getCurrentDate);

  const [periodoDiasChartData, setPeriodoDiasChartData] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const fetchTicketsPorDiaPeriodo = async () => {
        try {
          const { data } = await api.get("/tickets-por-dia-periodo", {
            params: {
              initialSelectedDate,
              finalSelectedDate,
            },
          });

          setPeriodoDiasChartData(data.ticketsPorDiaPeriodo);
        } catch (error) {
          toast.error("Erro ao carregar gráfico de Tickets por Dia (Período)!");
        }
      };

      fetchTicketsPorDiaPeriodo();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [initialSelectedDate, finalSelectedDate]);

  return (
    <React.Fragment>
      <Title>{"Tickets por Dia (Período)"}</Title>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <TextField
          label={"Data inicial"}
          type="date"
          value={initialSelectedDate}
          onChange={(e) => setInitialSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          label={"Data final"}
          type="date"
          value={finalSelectedDate}
          onChange={(e) => setFinalSelectedDate(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <ResponsiveContainer>
        <AreaChart
          data={periodoDiasChartData}
          margin={{ top: 16, right: 16, bottom: 0, left: 24 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="createdAt" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: "middle", fill: theme.palette.text.primary }}
            >
              {"Ticket"}
            </Label>
          </YAxis>
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="quantidade"
            stroke={theme.palette.primary.main}
            strokeWidth={2}
            fillOpacity={0.7}
            fill={theme.palette.primary.light}
            activeDot={{ r: 8 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};
export default ChartPorDiaPeriodo;
